import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import CommitteeCard from './CommitteeCard';
import CommitteeBanner from '../../CommitteeBanner';

const PLACEHOLDER_HEIGHT = 200;

const LazyCommitteeCard = (props) => {
  const { committee, reportStatus, index } = props;
  const [isVisible, setIsVisible] = useState(index < 2);
  const ref = useRef(null);

  useEffect(() => {
    if (isVisible || !ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' },
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [isVisible]);

  if (isVisible) {
    return <CommitteeCard {...props} />;
  }

  const statusBadge = (
    <span
      className={`badge border border-${reportStatus.variant} text-${reportStatus.variant} bg-white`}
    >
      Report {reportStatus.label}
    </span>
  );

  return (
    <div ref={ref} className="committee-section">
      <CommitteeBanner
        name={committee.sectionalCommitteeName}
        badges={statusBadge}
      />
      <Card className="card-two table-responsive">
        <Card.Body>
          <div style={{ minHeight: PLACEHOLDER_HEIGHT }} />
        </Card.Body>
      </Card>
    </div>
  );
};

LazyCommitteeCard.propTypes = {
  ...CommitteeCard.propTypes,
  index: PropTypes.number.isRequired,
};

LazyCommitteeCard.defaultProps = {
  ...CommitteeCard.defaultProps,
};

export default LazyCommitteeCard;
